import {
  GET_MERCHANT_AGREEMENTS_SUCCESS, 
  MERCHANT_AGREEMENTS_API_ERROR
} from "./actionTypes"

const INIT_STATE = {
  merchantAgreementList: [],
  error: {}
}

const merchantAgreement = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_MERCHANT_AGREEMENTS_SUCCESS:
      return {
        ...state,
        merchantAgreementList: action.payload,
      }
    case MERCHANT_AGREEMENTS_API_ERROR:
      return {
        ...state,
        error: action.payload,
      }
    default:
      return state
  }
}

export default merchantAgreement